import Model from '../Model'

export default class WithdrawalBankTransfer extends Model {
  resource() {
    return 'admin/bank-transfer/withdrawals'
  }
}
